const Wishlist = {
  key: 'wishlist',

  get() {
    try {
      return JSON.parse(localStorage.getItem(this.key)) || [];
    } catch {
      return [];
    }
  },

  save(handles) {
    localStorage.setItem(this.key, JSON.stringify(handles));
    this.updateBubble();
  },

  updateBubble() {
    const bubble = document.getElementById('wishlist-count-bubble');
    if (!bubble) return;
    const c = this.get().length;
    if (c > 0) {
      bubble.style.display = '';
      bubble.textContent = c;
    } else {
      bubble.style.display = 'none';
    }
  },

  add(handle) {
    const handles = this.get();
    if (!handles.includes(handle)) {
      handles.push(handle);
      this.save(handles);
    }
  },

  remove(handle) {
    const handles = this.get().filter(h => h !== handle);
    this.save(handles);
  },

  contains(handle) {
    return this.get().includes(handle);
  },

  count() {
    return this.get().length;
  }
};

/* Product page: toggle heart button */
function initWishlistButton() {
  const btn = document.querySelector('.wishlist-btn');
  if (!btn) return;

  const handle = btn.dataset.handle;

  if (Wishlist.contains(handle)) {
    btn.classList.add('wishlist-btn--active');
  }

  btn.addEventListener('click', function() {
    if (Wishlist.contains(handle)) {
      Wishlist.remove(handle);
      btn.classList.remove('wishlist-btn--active');
    } else {
      Wishlist.add(handle);
      btn.classList.add('wishlist-btn--active');
    }
  });
}

/* Wishlist page: render saved products */
function initWishlistPage() {
  const grid = document.getElementById('wishlist-grid');
  const emptyMsg = document.getElementById('wishlist-empty');
  if (!grid) return;

  const currency = grid.dataset.currency || 'SEK';
  const textView = grid.dataset.textView || 'View Product';
  const textRemove = grid.dataset.textRemove || 'Remove';

  function formatMoney(amount) {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  }

  const handles = Wishlist.get();

  if (handles.length === 0) {
    emptyMsg.style.display = 'block';
    grid.style.display = 'none';
    return;
  }

  emptyMsg.style.display = 'none';
  grid.style.display = 'grid';

  handles.forEach(handle => {
    fetch(`/products/${handle}.json`)
      .then(res => {
        if (!res.ok) throw new Error('Product not found');
        return res.json();
      })
      .then(({ product }) => {
        const price = formatMoney(product.variants[0].price);
        const image = product.images[0]
          ? product.images[0].src
          : 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png';

        const card = document.createElement('div');
        card.className = 'wishlist-card';
        card.dataset.handle = handle;
        card.innerHTML = `
          <a href="/products/${handle}" class="wishlist-card__image-link">
            <img src="${image}" alt="${product.title}" loading="lazy" width="400" height="400">
          </a>
          <div class="wishlist-card__info">
            <a href="/products/${handle}" class="wishlist-card__title">${product.title}</a>
            <p class="wishlist-card__price">${price}</p>
            <div class="wishlist-card__actions">
              <a href="/products/${handle}" class="wishlist-card__view button button--primary">${textView}</a>
              <button type="button" class="wishlist-card__remove" aria-label="${textRemove}">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                ${textRemove}
              </button>
            </div>
          </div>
        `;

        card.querySelector('.wishlist-card__remove').addEventListener('click', () => {
          Wishlist.remove(handle);
          card.remove();
          if (Wishlist.count() === 0) {
            emptyMsg.style.display = 'block';
            grid.style.display = 'none';
          }
        });

        grid.appendChild(card);
      })
      .catch(() => {
        /* Product no longer exists — remove from wishlist silently */
        Wishlist.remove(handle);
      });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  Wishlist.updateBubble();
  initWishlistButton();
  initWishlistPage();
});
